import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
  transform(value) {
    const keys = Object.keys(value);
    return keys;
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/pipes/keys.pipe.ts